import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_sparkle-tidycare/artifacts/d39d81c2b8d010cd_IMG_9276.PNG";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-obsidian text-ivory">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="inline-block rounded-lg bg-ivory p-3">
              <img src={LOGO_URL} alt="TidyCare" className="h-12 w-auto" data-testid="footer-logo" />
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/60">
              Auckland's premium cleaning atelier. Five-star housekeeping
              standards for the homes and workplaces you care about most.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-champagne">Pages</h4>
            <ul className="mt-5 space-y-3 text-sm text-ivory/70">
              <li><Link data-testid="footer-link-home" to="/" className="transition-colors duration-300 hover:text-gold">Home</Link></li>
              <li><Link data-testid="footer-link-services" to="/services" className="transition-colors duration-300 hover:text-gold">Services</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="transition-colors duration-300 hover:text-gold">About</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors duration-300 hover:text-gold">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-champagne">Services</h4>
            <ul className="mt-5 space-y-3 text-sm text-ivory/70">
              <li>Residential Cleaning</li>
              <li>Commercial &amp; Office</li>
              <li>Deep Sanitisation</li>
              <li>Move In / Out Cleans</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-champagne">Contact</h4>
            <ul className="mt-5 space-y-3 text-sm text-ivory/70">
              <li className="flex items-center gap-3">
                <Phone size={15} className="text-gold" />
                <a data-testid="footer-phone" href="tel:+64225038702" className="transition-colors duration-300 hover:text-gold">022 503 8702</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={15} className="text-gold" />
                <a data-testid="footer-email" href="mailto:tidycare@hotmail.com" className="transition-colors duration-300 hover:text-gold">tidycare@hotmail.com</a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={15} className="text-gold" /> Auckland, New Zealand
              </li>
              <li className="flex items-center gap-3">
                <Clock size={15} className="text-gold" /> Mon – Sat, 7am – 7pm
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-ivory/10 pt-8 text-xs text-ivory/40 md:flex-row">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} TidyCare Ltd. All rights reserved.</p>
          <p>Proudly serving Tāmaki Makaurau, Auckland</p>
        </div>
      </div>
    </footer>
  );
}
